import { faUserClock } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import {
    FormGroup,
    Container
} from 'reactstrap';
import _ from 'lodash-es';
import CommonContext, { ApiRoutes } from '../Common';
import {
    FlexCenterRow,
    toasty,
} from '../common/forms/FormElements';
import SlideForm from '../common/forms/SlideForm';
import { BaseFormViewModel } from '../common/ViewModel';
import { util } from '../Util';
import { handleFormSaveError } from '../common/forms/ValidationError';
import { SignatureReviewTableAll } from './SignatureReviewTableAll';
import './ClientReview.scss';
import SignatureButton from '../common/forms/SignatureButton';
import { TimesheetSignatureType } from './ClientReview';
import { onTextAnswerChanged, onSelectAnswerChanged, onSelectChanged } from '../formsAndSurveys/SurveyQuestion';

export default class EmployeeReviewAll extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.signatureRef = React.createRef();
        const stateBase = {
            reviews: [],
            employees: [],
            formValidated: false,
            isOpen: false,
            signatureTypes: [],
            selectedEmployeeId: null,
            selectedReview: {},
            timesheetId: null,
            displayReuse: false,
            ...new BaseFormViewModel(),
        };
        this.baseState = stateBase;
        this.state = stateBase;
        this.resetForm = this.resetForm.bind(this);

        this.onReviewTextAnswerChanged = this.onReviewTextAnswerChanged.bind(this);
        this.onReviewSelectAnswerChanged = this.onReviewSelectAnswerChanged.bind(this);
        this.onReviewSelectChanged = this.onReviewSelectChanged.bind(this);
    }

    componentDidUpdate() {
    }

    onChangeNotes = (e) => {
        const { selectedReview } = this.state;
        selectedReview.notes = e.target.value;
        this.setState({ selectedReview });
    };

    onClear = () => {
        this.eSigPad.clear();
    };

    onClose = () => {
        this.resetForm();
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        this.props.onClose();
    };

    onDelete = async (e) => {

    };

    onEmployeeSelected = (employee) => {
        const { reviews } = { ...this.state };
        const selectedReview = reviews.find((x) => x.employeeId == employee.value);

        this.setState({ selectedReview, selectedEmployeeId: employee.value });
    };

    onMissingSigReasonChanged = (reason) => {
        const { selectedReview } = { ...this.state };
        selectedReview.missingSigReasonId = reason.value;
        this.setState({ selectedReview });
    };

    onReuseSignatureChanged = (e) => {
        const include = e.target.checked;
        const { selectedReview } = { ...this.state };
        selectedReview.reuseEmployeeSignature = include;
        this.setState({ selectedReview });
    };

    onReviewSelectAnswerChanged = onSelectAnswerChanged;

    onReviewSelectChanged = onSelectChanged;

    // #region Questions/Answers
    onReviewTextAnswerChanged = onTextAnswerChanged;

    onSave = async () => {
        const { selectedReview, timesheetId } = { ...this.state };
        const { tenantSettings } = { ...this.props };

        const errors = [];

        if (selectedReview.signatureTypeId !== TimesheetSignatureType.EmployeeNoSignature) {
            if (!((!!selectedReview.reviewSignature.signatureData
                    // Make sure it's not just the mime type prefix.
                    && selectedReview.reviewSignature.signatureData !== 'data:image/png;base64,') && (selectedReview.newEmployeeSignature || selectedReview.reuseEmployeeSignature))
            ) {
                errors.push('A signature is required.');
            }
        } else {
            // no signature notes or reason is required.
            if (!tenantSettings.enablePredefinedTimesheetMissingSigReason && !selectedReview.notes) {
                errors.push('Provide a reason there was no signature.');
            }
            if (!!tenantSettings.enablePredefinedTimesheetMissingSigReason && !selectedReview.missingSigReasonId) {
                errors.push('Reason for no signature - a selection is required in the drop down.');
            }
        }

        let requiredQuestionsAnswered = true;

        if (selectedReview.questions.length) {
            if (selectedReview.questions.some((q) => q.answerRequired)) {
                const requiredQuestions = selectedReview.questions.filter((q) => q.answerRequired);

                requiredQuestions.forEach((rq) => {
                    const ans = selectedReview.answers.filter((x) => x.questionId === rq.id) ?? [];

                    if (!ans.length) {
                        requiredQuestionsAnswered = false;
                    }
                });
            }
        }

        if (!!selectedReview.chargeTypeQuestionGroups?.length ?? false) {
            const ctqs = selectedReview.chargeTypeQuestionGroups.flatMap((ctqg) => ctqg.chargeTypeQuestions);

            if (ctqs.some((q) => q.answerRequired)) {
                const requiredCTQs = ctqs.filter((q) => q.answerRequired);

                requiredCTQs.forEach((rq) => {
                    const ans = selectedReview.chargeTypeAnswers.filter((a) => a.questionId === rq.id) ?? [];

                    if (!ans.length) {
                        requiredQuestionsAnswered = false;
                    }
                });
            }
        }

        if (!requiredQuestionsAnswered) {
            errors.push('Some required questions are missing an answer');
        }

        if (errors.length) {
            const errorsstring = errors.join(' ');
            toasty.error(errorsstring);
            this.setState({ formValidated: true });
            return;
        }

        try {
            // Questions are for display purpose only; they should not be passed with update data.
            selectedReview.questions = [];
            await util.fetch.post(ApiRoutes.timesheetReview.update(), selectedReview);
            toasty.success('Saved');
            this.open(timesheetId);
        } catch (err) {
            toasty.error(`We were unable to save your timesheet review.  Message from the server: ${err}`);
        }
    };

    onSigSavedCallback = async (sigData) => {
        const { selectedReview } = { ...this.state };

        for (var i = 0; i < selectedReview.length; i++) {
            selectedReview[i].reviewSignature.signatureData = sigData;
            selectedReview[i].newEmployeeSignature = true;
            selectedReview[i].reviewSignature.sigIsComplete = true;

            await util.fetch.post(ApiRoutes.timesheetReview.update(), selectedReview[i]);
        }

        this.setState({ selectedReview });

        this.resetForm();
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        this.props.onSaved();
    };

    onSignatureTypeChanged = (signatureType) => {
        const { selectedReview } = { ...this.state };

        selectedReview.signatureTypeId = signatureType.value;

        if (selectedReview.signatureTypeId === TimesheetSignatureType.EmployeeNoSignature) {
            selectedReview.reviewSignature.signatureData = null;
            selectedReview.reviewSignature.sigIsComplete = false;
        }

        this.setState({ SelectedReview: selectedReview });
    };

    setRef = (ref) => {
    // keep a reference to the dom ref as an instance property
        this.ref = ref;
    // give the dom ref to react-beautiful-dnd
    // this.props.innerRef(ref);
    };

    handleSaveError = (err) => handleFormSaveError(this, err);

    open = async (timesheetId) => {
        this.setState(this.baseState);
        await this.setState({ loading: true });

        let reviews = null;

        this.resetForm();

        await this.populateState();

        if (timesheetId) {
            reviews = await util.fetch.js(ApiRoutes.timesheetReview.employeesAllByTimesheetId(timesheetId));
        } else {
            reviews = null;//
        }

        // if none then close i guess as its likely complete?
        if (!reviews.length) {
            this.onClose();
            return;
        }

        this.props.toggleShow(true);
        this.context.setFormOpened(true);

        const review = reviews.find((x) => x.employeeId == reviews[0].employeeId);

        const displayReuse = !!review.reviewSignature && !!review.reviewSignature.signatureData;
        // Remove "No Signature" option if this is the crewlead
        let { signatureTypes } = { ...this.state };

        const employeeReview = reviews.find((x) => x.employeeId == this.context?.user?.employeeId);
        const isCrewLead = employeeReview?.isCrewLead;
        if (isCrewLead) {
            signatureTypes = signatureTypes.filter((x) => x.label !== 'No Signature');
        }

        await this.setState({
            reviews,
            loading: false,
            timesheetId,
            employees: reviews.map((x) => ({ value: x.employeeId, label: x.employeeFullName })),
            selectedReview: reviews,
            selectedEmployeeId: reviews[0].employeeId,
            signatureTypes,
            displayReuse,
        });
    };

    async populateState() {
        const [signatureTypes, missingSigReasons] = await Promise.all([
            util.fetch.js(ApiRoutes.typeAheads.crewSignatureTypes()),
            util.fetch.js(ApiRoutes.timesheetReview.missingSignatureReasons()),
        ]);

        this.setState({
            signatureTypes,
            missingSignatureReasons: missingSigReasons,
        });
    }

    resetForm = () => this.setState({ formValidated: false });

    // #endregion
    render() {
        const {
            reviews,
            selectedReview,
            formValidated,
            validationMessage,
        } = { ...this.state };

        if (!reviews) return null;

        return (
            <SlideForm
                size="col-xl-6 col-lg-6 col-md-12 col-sm-12"
                loading={this.state.loading}
                show={this.props.show}
                id="employeeReview"
                formIcon={faUserClock}
                formTitle="Job Review / Signature"
                ref={this.formRef}
                setIsValidated={(value) => { this.setState({ formValidated: value }); }}
                isValidated={formValidated}
                onClose={this.onClose}
                onDelete={this.onDelete}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                validationMessage={validationMessage}
            >
                
                <div className='confirmationContainer'>
                    <Container>
                        {
                            !_.isEmpty(selectedReview)
                            && (
                                <>
                                    <FormGroup>
                                        <SignatureReviewTableAll
                                            timeCharges={selectedReview}
                                            hourlyTimesheets={this.props.hourlyTimesheets}
                                            tonnageTimesheets={this.props.tonnageTimesheets}
                                            hoursTotal={this.props.hoursTotal}
                                            tonnageHoursTotal={this.props.tonnageHoursTotal}
                                            tonnageTotal={this.props.tonnageTotal}
                                        />
                                    </FormGroup>
                                
                                    
                                </>
                            )
                        }
                    </Container>
                </div>

                <FlexCenterRow className="mt-2">
                    <SignatureButton
                        id="employeeReviewButton"
                        ref={(ref) => this.signatureRef = ref}
                        onSigSavedCallback={this.onSigSavedCallback}
                        sigData={selectedReview?.reviewSignature?.signatureData}
                        signatureLabel='Sign and Submit'
                    />
                </FlexCenterRow>

            </SlideForm>

        );
    }
}
